import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import AuthShell from '../components/AuthShell';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally { setLoading(false); }
  };

  return (
    <AuthShell>
      {sent ? (
        <>
          {/* Success state */}
          <div style={{ marginBottom: 28 }}>
            <div style={{
              width: 44, height: 44, borderRadius: 14, marginBottom: 20,
              background: 'rgba(108,150,156,0.14)', border: '1px solid rgba(124,172,183,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="20" height="20" fill="none" stroke="var(--tandm-accent-light)" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h1 style={{
              fontFamily: 'var(--tandm-font-display)',
              fontSize: 32, fontWeight: 500, color: 'var(--tandm-on-dark)',
              letterSpacing: '-0.03em', margin: '0 0 6px', lineHeight: 1.1,
            }}>
              Check your<br />
              <span style={{
                background: 'var(--tandm-gradient-text)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>inbox.</span>
            </h1>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', margin: 0, lineHeight: 1.6 }}>
              If an account exists for <span style={{ color: 'rgba(255,255,255,0.6)' }}>{email}</span>,
              we've sent a link to reset your password. The link expires in 1 hour.
            </p>
          </div>
          <p style={{ textAlign: 'center', fontSize: 13, color: 'rgba(255,255,255,0.3)', margin: 0 }}>
            Didn't get it?{' '}
            <button
              onClick={() => setSent(false)}
              className="lf-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', padding: 0 }}
            >
              Try again
            </button>
          </p>
        </>
      ) : (
        <>
          {/* Headline */}
          <div style={{ marginBottom: 32 }}>
            <h1 style={{
              fontFamily: 'var(--tandm-font-display)',
              fontSize: 32, fontWeight: 500, color: 'var(--tandm-on-dark)',
              letterSpacing: '-0.03em', margin: '0 0 6px', lineHeight: 1.1,
            }}>
              Forgot your<br />
              <span style={{
                background: 'var(--tandm-gradient-text)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>password?</span>
            </h1>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', margin: 0 }}>
              Enter your email and we'll send you a reset link
            </p>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)',
              color: '#FCA5A5', borderRadius: 10, padding: '10px 14px',
              marginBottom: 20, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {error}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div>
              <label className="lf-label">Email</label>
              <input
                name="email" type="email" required autoFocus
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="lf-input" placeholder="jane@university.ac.uk"
              />
            </div>

            <button type="submit" disabled={loading} className="lf-btn" style={{ marginTop: 4 }}>
              {loading
                ? <><div className="lf-spinner" />Sending link...</>
                : <>Send reset link <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg></>
              }
            </button>
          </form>
        </>
      )}

      {/* Footer */}
      <p style={{ textAlign: 'center', fontSize: 13, color: 'rgba(255,255,255,0.3)', marginTop: 24, marginBottom: 0 }}>
        Remembered it?{' '}
        <Link to="/login" className="lf-link">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
